const countriesOpts = [
  { id: 1, value: "Afghanistan", label: "Afghanistan" },
  { id: 2, value: "Albania", label: "Albania" },
  { id: 3, value: "Algeria", label: "Algeria" },
  { id: 4, value: "American Samoa", label: "American Samoa" },
  { id: 5, value: "Andorra", label: "Andorra" },
  { id: 6, value: "Angola", label: "Angola" },
  { id: 7, value: "Anguilla", label: "Anguilla" },
  { id: 8, value: "Antarctica", label: "Antarctica" },
  { id: 9, value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
  { id: 10, value: "Argentina", label: "Argentina" },
  { id: 11, value: "Armenia", label: "Armenia" },
  { id: 12, value: "Aruba", label: "Aruba" },
  { id: 13, value: "Australia", label: "Australia" },
  { id: 14, value: "Austria", label: "Austria" },
  { id: 15, value: "Azerbaijan", label: "Azerbaijan" },
  { id: 16, value: "Bahamas", label: "Bahamas" },
  { id: 17, value: "Bahrain", label: "Bahrain" },
  { id: 18, value: "Bangladesh", label: "Bangladesh" },
  { id: 19, value: "Barbados", label: "Barbados" },
  { id: 20, value: "Belarus", label: "Belarus" },
  { id: 21, value: "Belgium", label: "Belgium" },
  { id: 22, value: "Belize", label: "Belize" },
  { id: 23, value: "Benin", label: "Benin" },
  { id: 24, value: "Bermuda", label: "Bermuda" },
  { id: 25, value: "Bhutan", label: "Bhutan" },
  { id: 26, value: "Bolivia", label: "Bolivia" },
  { id: 27, value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
  { id: 28, value: "Botswana", label: "Botswana" },
  { id: 29, value: "Bouvet Island", label: "Bouvet Island" },
  { id: 30, value: "Brazil", label: "Brazil" },
  {
    id: 31,
    value: "British Indian Ocean Territory",
    label: "British Indian Ocean Territory",
  },
  { id: 32, value: "Brunei Darussalam", label: "Brunei Darussalam" },
  { id: 33, value: "Bulgaria", label: "Bulgaria" },
  { id: 34, value: "Burkina Faso", label: "Burkina Faso" },
  { id: 35, value: "Burundi", label: "Burundi" },
  { id: 36, value: "Cambodia", label: "Cambodia" },
  { id: 37, value: "Cameroon", label: "Cameroon" },
  { id: 38, value: "Canada", label: "Canada" },
  { id: 39, value: "Cape Verde", label: "Cape Verde" },
  { id: 40, value: "Cayman Islands", label: "Cayman Islands" },
  {
    id: 41,
    value: "Central African Republic",
    label: "Central African Republic",
  },
  { id: 42, value: "Chad", label: "Chad" },
  { id: 43, value: "Chile", label: "Chile" },
  { id: 44, value: "China", label: "China" },
  { id: 45, value: "Christmas Island", label: "Christmas Island" },
  { id: 46, value: "Cocos Islands", label: "Cocos Islands" },
  { id: 47, value: "Colombia", label: "Colombia" },
  { id: 48, value: "Comoros", label: "Comoros" },
  { id: 49, value: "Congo", label: "Congo" },
  {
    id: 50,
    value: "Congo, Democratic Republic of the",
    label: "Congo, Democratic Republic of the",
  },
  { id: 51, value: "Cook Islands", label: "Cook Islands" },
  { id: 52, value: "Costa Rica", label: "Costa Rica" },
  { id: 53, value: "Cote d'Ivoire", label: "Cote d'Ivoire" },
  { id: 54, value: "Croatia", label: "Croatia" },
  { id: 55, value: "Cuba", label: "Cuba" },
  { id: 56, value: "Cyprus", label: "Cyprus" },
  { id: 57, value: "Czech Republic", label: "Czech Republic" },
  { id: 58, value: "Denmark", label: "Denmark" },
  { id: 59, value: "Djibouti", label: "Djibouti" },
  { id: 60, value: "Dominica", label: "Dominica" },
  { id: 61, value: "Dominican Republic", label: "Dominican Republic" },
  { id: 62, value: "Ecuador", label: "Ecuador" },
  { id: 63, value: "Egypt", label: "Egypt" },
  { id: 64, value: "El Salvador", label: "El Salvador" },
  { id: 65, value: "Equatorial Guinea", label: "Equatorial Guinea" },
  { id: 66, value: "Eritrea", label: "Eritrea" },
  { id: 67, value: "Estonia", label: "Estonia" },
  { id: 68, value: "Ethiopia", label: "Ethiopia" },
  { id: 69, value: "Falkland Islands", label: "Falkland Islands" },
  { id: 70, value: "Faroe Islands", label: "Faroe Islands" },
  { id: 71, value: "Fiji", label: "Fiji" },
  { id: 72, value: "Finland", label: "Finland" },
  { id: 73, value: "France", label: "France" },
  { id: 74, value: "French Guiana", label: "French Guiana" },
  { id: 75, value: "French Polynesia", label: "French Polynesia" },
  { id: 76, value: "Gabon", label: "Gabon" },
  { id: 77, value: "Gambia", label: "Gambia" },
  { id: 78, value: "Georgia", label: "Georgia" },
  { id: 79, value: "Germany", label: "Germany" },
  { id: 80, value: "Ghana", label: "Ghana" },
  { id: 81, value: "Gibraltar", label: "Gibraltar" },
  { id: 82, value: "Greece", label: "Greece" },
  { id: 83, value: "Greenland", label: "Greenland" },
  { id: 84, value: "Grenada", label: "Grenada" },
  { id: 85, value: "Guadeloupe", label: "Guadeloupe" },
  { id: 86, value: "Guam", label: "Guam" },
  { id: 87, value: "Guatemala", label: "Guatemala" },
  { id: 88, value: "Guinea", label: "Guinea" },
  { id: 89, value: "Guinea-Bissau", label: "Guinea-Bissau" },
  { id: 90, value: "Guyana", label: "Guyana" },
  { id: 91, value: "Haiti", label: "Haiti" },
  {
    id: 92,
    value: "Heard Island and McDonald Islands",
    label: "Heard Island and McDonald Islands",
  },
  { id: 93, value: "Honduras", label: "Honduras" },
  { id: 94, value: "Hong Kong", label: "Hong Kong" },
  { id: 95, value: "Hungary", label: "Hungary" },
  { id: 96, value: "Iceland", label: "Iceland" },
  { id: 97, value: "India", label: "India" },
  { id: 98, value: "Indonesia", label: "Indonesia" },
  { id: 99, value: "Iran", label: "Iran" },
  { id: 100, value: "Iraq", label: "Iraq" },
  { id: 101, value: "Ireland", label: "Ireland" },
  { id: 102, value: "Isle of Man", label: "Isle of Man" },
  { id: 103, value: "Israel", label: "Israel" },
  { id: 104, value: "Italy", label: "Italy" },
  { id: 105, value: "Jamaica", label: "Jamaica" },
  { id: 106, value: "Japan", label: "Japan" },
  { id: 107, value: "Jordan", label: "Jordan" },
  { id: 108, value: "Kazakhstan", label: "Kazakhstan" },
  { id: 109, value: "Kenya", label: "Kenya" },
  { id: 110, value: "Kiribati", label: "Kiribati" },
  { id: 237, value: "Kosovo", label: "Kosovo" },
  { id: 111, value: "Kuwait", label: "Kuwait" },
  { id: 112, value: "Kyrgyzstan", label: "Kyrgyzstan" },
  { id: 113, value: "Laos", label: "Laos" },
  { id: 114, value: "Latvia", label: "Latvia" },
  { id: 115, value: "Lebanon", label: "Lebanon" },
  { id: 116, value: "Lesotho", label: "Lesotho" },
  { id: 117, value: "Liberia", label: "Liberia" },
  { id: 118, value: "Libya", label: "Libya" },
  { id: 119, value: "Liechtenstein", label: "Liechtenstein" },
  { id: 120, value: "Lithuania", label: "Lithuania" },
  { id: 121, value: "Luxembourg", label: "Luxembourg" },
  { id: 122, value: "Macao", label: "Macao" },
  { id: 123, value: "Madagascar", label: "Madagascar" },
  { id: 124, value: "Malawi", label: "Malawi" },
  { id: 125, value: "Malaysia", label: "Malaysia" },
  { id: 126, value: "Maldives", label: "Maldives" },
  { id: 127, value: "Mali", label: "Mali" },
  { id: 128, value: "Malta", label: "Malta" },
  { id: 129, value: "Marshall Islands", label: "Marshall Islands" },
  { id: 130, value: "Martinique", label: "Martinique" },
  { id: 131, value: "Mauritania", label: "Mauritania" },
  { id: 132, value: "Mauritius", label: "Mauritius" },
  { id: 133, value: "Mayotte", label: "Mayotte" },
  { id: 134, value: "Mexico", label: "Mexico" },
  { id: 135, value: "Micronesia", label: "Micronesia" },
  { id: 136, value: "Moldova", label: "Moldova" },
  { id: 137, value: "Monaco", label: "Monaco" },
  { id: 138, value: "Mongolia", label: "Mongolia" },
  { id: 139, value: "Montenegro", label: "Montenegro" },
  { id: 140, value: "Montserrat", label: "Montserrat" },
  { id: 141, value: "Morocco", label: "Morocco" },
  { id: 142, value: "Mozambique", label: "Mozambique" },
  { id: 143, value: "Myanmar", label: "Myanmar" },
  { id: 144, value: "Namibia", label: "Namibia" },
  { id: 145, value: "Nauru", label: "Nauru" },
  { id: 146, value: "Nepal", label: "Nepal" },
  { id: 147, value: "Netherlands", label: "Netherlands" },
  { id: 148, value: "Netherlands Antilles", label: "Netherlands Antilles" },
  { id: 149, value: "New Caledonia", label: "New Caledonia" },
  { id: 150, value: "New Zealand", label: "New Zealand" },
  { id: 151, value: "Nicaragua", label: "Nicaragua" },
  { id: 152, value: "Niger", label: "Niger" },
  { id: 153, value: "Nigeria", label: "Nigeria" },
  { id: 154, value: "Norfolk Island", label: "Norfolk Island" },
  { id: 155, value: "North Korea", label: "North Korea" },
  { id: 156, value: "Norway", label: "Norway" },
  { id: 157, value: "Oman", label: "Oman" },
  { id: 158, value: "Pakistan", label: "Pakistan" },
  { id: 159, value: "Palau", label: "Palau" },
  { id: 160, value: "Palestinian Territory", label: "Palestinian Territory" },
  { id: 161, value: "Panama", label: "Panama" },
  { id: 162, value: "Papua New Guinea", label: "Papua New Guinea" },
  { id: 163, value: "Paraguay", label: "Paraguay" },
  { id: 164, value: "Peru", label: "Peru" },
  { id: 165, value: "Philippines", label: "Philippines" },
  { id: 166, value: "Pitcairn", label: "Pitcairn" },
  { id: 167, value: "Poland", label: "Poland" },
  { id: 168, value: "Portugal", label: "Portugal" },
  { id: 169, value: "Puerto Rico", label: "Puerto Rico" },
  { id: 170, value: "Qatar", label: "Qatar" },
  { id: 171, value: "Romania", label: "Romania" },
  { id: 172, value: "Russian Federation", label: "Russian Federation" },
  { id: 173, value: "Rwanda", label: "Rwanda" },
  { id: 174, value: "Saint Helena", label: "Saint Helena" },
  { id: 175, value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
  { id: 176, value: "Saint Lucia", label: "Saint Lucia" },
  {
    id: 177,
    value: "Saint Pierre and Miquelon",
    label: "Saint Pierre and Miquelon",
  },
  {
    id: 178,
    value: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  { id: 179, value: "Samoa", label: "Samoa" },
  { id: 180, value: "San Marino", label: "San Marino" },
  { id: 181, value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
  { id: 182, value: "Saudi Arabia", label: "Saudi Arabia" },
  { id: 183, value: "Senegal", label: "Senegal" },
  { id: 184, value: "Serbia", label: "Serbia" },
  { id: 185, value: "Seychelles", label: "Seychelles" },
  { id: 186, value: "Sierra Leone", label: "Sierra Leone" },
  { id: 187, value: "Singapore", label: "Singapore" },
  { id: 188, value: "Slovakia", label: "Slovakia" },
  { id: 189, value: "Slovenia", label: "Slovenia" },
  { id: 190, value: "Solomon Islands", label: "Solomon Islands" },
  { id: 191, value: "Somalia", label: "Somalia" },
  { id: 192, value: "South Africa", label: "South Africa" },
  { id: 193, value: "South Georgia", label: "South Georgia" },
  { id: 194, value: "South Korea", label: "South Korea" },
  { id: 195, value: "Spain", label: "Spain" },
  { id: 196, value: "Sri Lanka", label: "Sri Lanka" },
  { id: 197, value: "Sudan", label: "Sudan" },
  { id: 198, value: "Suriname", label: "Suriname" },
  { id: 199, value: "Svalbard and Jan Mayen", label: "Svalbard and Jan Mayen" },
  { id: 200, value: "Swaziland", label: "Swaziland" },
  { id: 201, value: "Sweden", label: "Sweden" },
  { id: 202, value: "Switzerland", label: "Switzerland" },
  { id: 203, value: "Syrian Arab Republic", label: "Syrian Arab Republic" },
  { id: 204, value: "Taiwan", label: "Taiwan" },
  { id: 205, value: "Tajikistan", label: "Tajikistan" },
  { id: 206, value: "Tanzania", label: "Tanzania" },
  { id: 207, value: "Thailand", label: "Thailand" },
  {
    id: 208,
    value: "The Former Yugoslav Republic of Macedonia",
    label: "The Former Yugoslav Republic of Macedonia",
  },
  { id: 209, value: "Timor-Leste", label: "Timor-Leste" },
  { id: 210, value: "Togo", label: "Togo" },
  { id: 211, value: "Tokelau", label: "Tokelau" },
  { id: 212, value: "Tonga", label: "Tonga" },
  { id: 213, value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
  { id: 214, value: "Tunisia", label: "Tunisia" },
  { id: 215, value: "Turkey", label: "Turkey" },
  { id: 216, value: "Turkmenistan", label: "Turkmenistan" },
  { id: 217, value: "Tuvalu", label: "Tuvalu" },
  { id: 218, value: "Uganda", label: "Uganda" },
  { id: 219, value: "Ukraine", label: "Ukraine" },
  { id: 220, value: "United Arab Emirates", label: "United Arab Emirates" },
  { id: 221, value: "United Kingdom", label: "United Kingdom" },
  { id: 222, value: "United States", label: "United States" },
  {
    id: 223,
    value: "United States Minor Outlying Islands",
    label: "United States Minor Outlying Islands",
  },
  { id: 224, value: "Uruguay", label: "Uruguay" },
  { id: 225, value: "Uzbekistan", label: "Uzbekistan" },
  { id: 226, value: "Vanuatu", label: "Vanuatu" },
  { id: 227, value: "Vatican City", label: "Vatican City" },
  { id: 228, value: "Venezuela", label: "Venezuela" },
  { id: 229, value: "Vietnam", label: "Vietnam" },
  {
    id: 230,
    value: "Virgin Islands, British",
    label: "Virgin Islands, British",
  },
  { id: 231, value: "Virgin Islands, U.S.", label: "Virgin Islands, U.S." },
  { id: 232, value: "Wallis and Futuna", label: "Wallis and Futuna" },
  { id: 233, value: "Western Sahara", label: "Western Sahara" },
  { id: 234, value: "Yemen", label: "Yemen" },
  { id: 235, value: "Zambia", label: "Zambia" },
  { id: 236, value: "Zimbabwe", label: "Zimbabwe" },
];

export default countriesOpts;
